module.exports = __webpack_public_path__ + "img/Ziegen.b6a03d43.svg";